import { Group, Select } from '@mantine/core';
import { useCreateRuleFormContext } from 'context/FormContext';
import { snakeCase } from 'lodash';
import { RuleDirections, RuleParameters } from 'models/rules';
import { useTranslation } from 'react-i18next';
import { displayFormError } from 'utils/validation';
import { TimeWindowField } from './TimeWindowField';
import { PhysiologicalValueField } from './PhysiologicalValueField';

export const PhysiologicalParameterChangeFields = () => {
  const { t } = useTranslation();
  const { getInputProps, values, setFieldValue, errors } = useCreateRuleFormContext();

  const dataField = 'data.physiologicalParameterChange';

  const handleParameterChange = (value: string | null) => {
    if (!value) return;
    setFieldValue(`${dataField}.parameter`, value);
    setFieldValue(`${dataField}.value`, undefined);
  };

  return (
    <>
      <Group justify={'flex-start'}>
        <Select
          label={t('parameter_label')}
          data={Object.values(RuleParameters)
            .filter((value) => ![RuleParameters.heartRate].includes(value))
            .map((value) => ({
              value,
              label: t(`${snakeCase(value)}_label`),
            }))}
          placeholder={t('select_parameter_label')}
          {...getInputProps(`${dataField}.parameter`)}
          onChange={handleParameterChange}
          disabled={values.formDisabled}
          error={displayFormError({ errors, dataField: `${dataField}.parameter`, label: t('empty_value_select') })}
        />
      </Group>
      <Group gap={'md'} align={'flex-start'}>
        <Select
          label={t('direction_label')}
          {...getInputProps(`${dataField}.direction`)}
          data={Object.values(RuleDirections).map((value) => ({
            value,
            label: t(`${value}_label`),
          }))}
          w={130}
          disabled={!getInputProps(`${dataField}.parameter`).value || values.formDisabled}
        />
        <PhysiologicalValueField dataField={dataField} fieldName={'value'} />
        <TimeWindowField
          dataField={`${dataField}.timeWindow`}
          disabled={!getInputProps(`${dataField}.parameter`).value || values.formDisabled}
        />
      </Group>
    </>
  );
};
